import { useCallback, useRef, useState } from 'react';

import { Variants, useReducedMotion } from 'framer-motion';

import { useClickOutside } from 'hooks/browser/outerClick';

export const useToggleMenu = () => {
  const hideTimeout = useRef<NodeJS.Timeout | undefined>(undefined);

  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const showMenu = useCallback(() => {
    clearTimeout(hideTimeout.current);
    setIsMenuVisible(true);
  }, []);

  const hideMenu = useCallback(() => {
    clearTimeout(hideTimeout.current);
    hideTimeout.current = setTimeout(() => setIsMenuVisible(false), 250);
  }, []);

  const ref = useRef<HTMLDivElement>(null);
  useClickOutside(ref, hideMenu);

  return {
    isMenuVisible,
    showMenu,
    hideMenu,
    ref,
  };
};

export const useVariants = () => {
  const shouldReduceMotion = useReducedMotion();

  const variants: Variants = {
    hidden: {
      transform: shouldReduceMotion
        ? 'translateY(100%)'
        : 'translateY(-12px) translateY(100%)',
      opacity: shouldReduceMotion ? 1 : 0,
    },
    show: {
      transform: shouldReduceMotion
        ? 'translateY(100%)'
        : 'translateY(0px) translateY(100%)',
      opacity: 1,
    },
  };

  return { variants };
};
